import { render, staticRenderFns } from "./TrStepByStepComicsV2.vue?vue&type=template&id=a33c1f98&scoped=true&"
import script from "./TrStepByStepComicsV2.vue?vue&type=script&lang=js&"
export * from "./TrStepByStepComicsV2.vue?vue&type=script&lang=js&"
import style0 from "./TrStepByStepComicsV2.vue?vue&type=style&index=0&id=a33c1f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33c1f98",
  null
  
)

export default component.exports